import React from 'react'
import { Button, Col, Dropdown, Form, InputGroup, Row } from 'react-bootstrap'
import DashboardTable from '@components/pages/Dashboard/DashboardTable.component'
import { trendAnalysisData } from '@components/pages/Dashboard/DashboardMockData'
import { usePracticeClinics } from '@hooks/usePracticeClinics'

const RADIO_BTN_OPT = ['Location', 'Provider']
const ACTION_ITEM = ['Save View', 'Reset']

function TrendAnalysis(): React.ReactElement {
  const clinics = usePracticeClinics()
  const column = [
    {
      field: 'kpi',
      header: 'KPI',
      width: '150',
    },
    {
      field: 'ytd',
      header: '2023 YTD',
      width: '50',
    },
    {
      field: 'aug',
      header: 'Aug 23 MTD',
      width: '50',
    },
    {
      field: 'jul',
      header: 'Jul 23',
      width: '50',
    },
    {
      field: 'jun',
      header: 'Jun 23',
      width: '50',
    },
    {
      field: 'may',
      header: 'May 23',
      width: '50',
    },
    {
      field: 'apr',
      header: 'Apr 23',
      width: '50',
    },
    {
      field: 'mar',
      header: 'Mar 23',
      width: '50',
    },
    {
      field: 'feb',
      header: 'Feb 23',
      width: '50',
    },
  ]
  return (
    <>
      <Row className="mb-0">
        <Col md={12} className="mb-0">
          <hr className="mt-1 mb-3" />
          <Row>
            <Col md={2} className="">
              <Row>
                <Col md={4}>
                  <Form className="pt-0">
                    <div key={`1`} className="mb-3">
                      {RADIO_BTN_OPT.map((opt) => (
                        <Form.Check
                          className="trend-analysis"
                          key={opt}
                          type={'radio'}
                          id={`${opt}Option`}
                          name={'options'}
                          label={opt}
                        />
                      ))}
                    </div>
                  </Form>
                </Col>
                <Col md={8} className="">
                  <Dropdown className="d-inline-block action-btn p-2 ">
                    <Dropdown.Toggle
                      id="dropdown-basic"
                      className="action-btn "
                    >
                      Select Location
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="p-3 select-loc">
                      <InputGroup className="mb-2">
                        <InputGroup.Text className="br-0">
                          <i className="fa fa-magnifying-glass"></i>
                        </InputGroup.Text>
                        <Form.Control
                          type="text"
                          placeholder="Search Location"
                        />
                      </InputGroup>
                      <div className="mt-4">Select Location</div>
                      <div className="list-loc-div">
                        {clinics.map((clinic) => (
                          <Dropdown.Item href="#" key={clinic.clinic_id}>
                            {clinic.clinic_name}
                          </Dropdown.Item>
                        ))}
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </Col>
              </Row>
            </Col>

            <Col md={2}>
              <Form.Group className="mb-1">
                <InputGroup>
                  <Form.Select value={''}>
                    <option key={''} value={''}>
                      Recommended KPIs
                    </option>
                  </Form.Select>
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={2} className="colDDFilter">
              <Form.Group className="mb-1">
                <InputGroup>
                  <Form.Select value={''}>
                    <option key={''} value={''}>
                      MOM
                    </option>
                  </Form.Select>
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={1}>
              <Dropdown className="d-inline-block action-btn p-2">
                <Dropdown.Toggle id="dropdown-basic" className="action-btn">
                  Action
                </Dropdown.Toggle>
                <Dropdown.Menu className="trtmt-shrtcts-dropdown">
                  {ACTION_ITEM.map((loc, index) => (
                    <Dropdown.Item href="#" key={`${index}-${loc}`}>
                      {loc}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </Col>
            <Col md={5} className="text-end">
              <div className="pt-1">
                <span className="btn-ct btn me-o">
                  Last Updated On: 10/18/2023, 8:00AM
                </span>
                <Button variant="light" className="btn-ct">
                  <i className="fa fa-file-export me-1"></i>
                  Export
                </Button>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <hr className="mt-0 mb-1" />
      <Row>
        <Col md={12}>
          <DashboardTable
            title={'Trend Analysis Header'}
            data={[]}
            columns={column}
            allowMultiSorting={false}
            allowSorting={false}
            classNameTable="trend-analysis-tbl1"
          />
          <div
            className="bg-custom3 text-dark fs-semibold"
            style={{ padding: '12px' }}
          >
            Collection
          </div>
          <DashboardTable
            title={'Trend Analysis - Collection'}
            data={trendAnalysisData.collection}
            columns={column}
            allowMultiSorting={false}
            allowSorting={false}
            classNameTable="trend-analysis-tbl"
          />
          <div
            className="bg-custom3 text-dark fs-semibold"
            style={{ padding: '12px' }}
          >
            Production
          </div>
          <DashboardTable
            title={'Trend Analysis - Production'}
            data={trendAnalysisData.production}
            columns={column}
            allowMultiSorting={false}
            allowSorting={false}
            classNameTable="trend-analysis-tbl"
          />
        </Col>
      </Row>
    </>
  )
}

export default TrendAnalysis
